// src/index.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Import thư viện CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./styles/scss/main.scss";

// Import WOW.js và CSS cần thiết
import WOW from "wowjs";
import "wowjs/css/libs/animate.css";
import "./styles/animate.css";
const root = ReactDOM.createRoot(document.getElementById("root"));

function Main() {
  useEffect(() => {
    // Khởi tạo WOW.js trong useEffect để đảm bảo chỉ chạy 1 lần
    new WOW.WOW({
      live: false, // live: false giúp WOW.js không tự động khởi tạo lại khi content thay đổi
    }).init();
  }, []); // Chạy chỉ 1 lần khi component được mount

  return <App />;
}

root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);
